'use strict';

bbw.model.UserSettingsGroup = ngtk.model.Abstract.extend({

    _groupFields: undefined,

    _data: undefined,

    _groupName: undefined,

    construct: function(groupName, defaults, values) {
        this._groupName = '' + groupName;
        this._groupFields = defaults;
        this._data = angular.copy(defaults);
        angular.isObject(values) && this.merge(values);
    },

    getName: function() {
        return this._groupName;
    },

    getValues: function() {
        var result = {};
        angular.forEach(this._data, function(value, key) {
            if (this._groupFields.hasOwnProperty(key)) {
                result[key] = value;
            }
        }.bind(this));
        return result;
    },

    _initialize: function() {
        this._data = {};
    },

    replace: function(itemData) {
        return this.clean().merge(itemData);
    },

    merge: function(mergeData) {
        angular.forEach(mergeData, function(value, key) {
            if (this._groupFields.hasOwnProperty(key)) {
                this._data[key] = value;
            }
        }.bind(this));
        return this;
    },

    clean: function() {
        ngtk.tools.object.empty(this._data);
        return this;
    },

    get: function(path) {
        if (!path) {
            return this.exportData();
        }
        if (!angular.isArray(path)) {
            path = ('' + path).split('.').filter(function(v) {
                return v.length > 0;
            });
        }
        var ptr = this._data;
        for (var i = 0; i < path.length; ++i) {
            var element = path[i];
            if (angular.isUndefined(ptr[element])) {
                return undefined;
            }
            ptr = ptr[element];
        }
        return ptr;
    },

    equals: function(item) {
        var id;
        if (item instanceof this.constructor) {
            id = item.getId();
        } else if (item) {
            id = this._extractIdFromItemData(item);
        }
        return angular.isDefined(id) && this.getId() == id;
    },

    exportData: function() {
        return this._data;
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        scopeInnerPtr[scopeInnerElement] = this._data;
        scopeInnerPtr[scopeInnerElement].$model = this;
    }

});